/**
 * @param arr The array to iterate over.
 * @param iteratee The iteratee to transform keys.
 * @returns The composed aggregate object.
 */
export const keyBy = (arr, iteratee) => {
    const map = {};
    for (let i = 0; i < arr.length; i++) {
        const value = arr[i];
        const key = typeof iteratee === 'function' ? iteratee(value) : value[iteratee];
        map[key] = value;
    }
    return map;
};
//# sourceMappingURL=array.js.map